export default __webpack_public_path__ + "static/media/summary_banner.1bb16e20.png";